import React, { useState, useEffect } from 'react';
import { COLORS } from '../App';
import { searchComps, selectComp, getComps } from '../api';

export default function CompSearch({ deal, onUpdate }) {
  const [comps, setComps] = useState([]);
  const [searching, setSearching] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    loadComps();
  }, [deal.id]);

  const loadComps = async () => {
    try {
      const res = await getComps(deal.id);
      setComps(res.data);
      setLoaded(true);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSearch = async () => {
    setSearching(true);
    try {
      const res = await searchComps(deal.id);
      setComps(res.data);
      onUpdate();
    } catch (err) {
      alert('Comp search failed: ' + err.message);
    }
    setSearching(false);
  };

  const handleToggle = async (compId, currentSelected) => {
    try {
      await selectComp(compId, !currentSelected);
      setComps(comps.map((c) => c.id === compId ? { ...c, selected: !currentSelected } : c));
    } catch (err) {
      alert('Failed to update comp: ' + err.message);
    }
  };

  const card = { background: COLORS.white, borderRadius: 8, border: `1px solid ${COLORS.border}`, padding: 24, marginBottom: 20 };

  return (
    <div>
      <h3 style={{ fontFamily: 'Georgia, serif', color: COLORS.navy, marginBottom: 20 }}>Comp Search</h3>

      <div style={card}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div>
            <h4 style={{ fontFamily: 'Georgia, serif', color: COLORS.navy }}>Annex Comp Search</h4>
            <p style={{ fontSize: 13, color: COLORS.textLight, marginTop: 4 }}>
              Search for comparable CMBS transactions matching {deal.property_type || 'this property'} in {deal.city || deal.state || 'the target market'}
            </p>
          </div>
          <button onClick={handleSearch} disabled={searching}
            style={{ padding: '10px 24px', background: COLORS.gold, color: COLORS.navy, border: 'none', borderRadius: 4, fontWeight: 600, cursor: 'pointer', fontSize: 14, opacity: searching ? 0.7 : 1 }}>
            {searching ? 'Searching...' : 'Search for Comps'}
          </button>
        </div>

        {comps.length > 0 && (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: `2px solid ${COLORS.border}` }}>
                {['Select', 'Property', 'Location', 'Type', 'Size', 'Debt Yield', 'LTV', 'Spread', 'Year', 'Match'].map((h) => (
                  <th key={h} style={{ textAlign: 'left', padding: '8px 10px', fontSize: 11, color: COLORS.textLight, fontWeight: 600, textTransform: 'uppercase' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {comps.map((c) => (
                <tr key={c.id} style={{ borderBottom: `1px solid ${COLORS.border}`, background: c.selected ? '#F0FFF4' : 'transparent' }}>
                  <td style={{ padding: '10px' }}>
                    <input type="checkbox" checked={c.selected} onChange={() => handleToggle(c.id, c.selected)} style={{ cursor: 'pointer' }} />
                  </td>
                  <td style={{ padding: '10px', fontSize: 13, fontWeight: 500 }}>{c.comp_property_name}</td>
                  <td style={{ padding: '10px', fontSize: 12, color: COLORS.text }}>{c.comp_location}</td>
                  <td style={{ padding: '10px', fontSize: 12, color: COLORS.text }}>{c.comp_property_type}</td>
                  <td style={{ padding: '10px', fontSize: 12, color: COLORS.text }}>{c.comp_size}</td>
                  <td style={{ padding: '10px', fontSize: 13, fontWeight: 600 }}>{c.comp_debt_yield ? c.comp_debt_yield + '%' : ''}</td>
                  <td style={{ padding: '10px', fontSize: 13 }}>{c.comp_ltv ? c.comp_ltv + '%' : ''}</td>
                  <td style={{ padding: '10px', fontSize: 12 }}>{c.comp_spread}</td>
                  <td style={{ padding: '10px', fontSize: 12 }}>{c.comp_year}</td>
                  <td style={{ padding: '10px' }}>
                    <div style={{
                      display: 'inline-block', padding: '2px 8px', borderRadius: 10, fontSize: 11, fontWeight: 600,
                      background: c.comp_match_score >= 80 ? '#D4EDDA' : c.comp_match_score >= 60 ? '#FFF3CD' : '#F8D7DA',
                      color: c.comp_match_score >= 80 ? '#155724' : c.comp_match_score >= 60 ? '#856404' : '#721C24',
                    }}>{c.comp_match_score}%</div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {loaded && comps.length === 0 && (
          <div style={{ textAlign: 'center', padding: 32, color: COLORS.textLight }}>
            No comps found yet. Click "Search for Comps" to find comparable transactions.
          </div>
        )}
      </div>

      {comps.length > 0 && (
        <div style={{ padding: '12px 16px', background: '#FFF8E1', borderRadius: 6, fontSize: 13, color: '#8D6E00', border: '1px solid #FFE082' }}>
          Note: If no comps are found at similar metrics, the deal may not be a strong fit for CMBS execution.
          Selected comps ({comps.filter((c) => c.selected).length}) will be included in generated documents.
        </div>
      )}
    </div>
  );
}
